import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
var colour = variables.colour;
export var container = {
  name: "pl2tu0",
  styles: "width:auto;display:flex;justify-content:center;align-items:center;"
};
export var dot = /*#__PURE__*/css("position:relative;display:block;width:8px;height:8px;border-radius:100%;background:", colour.neutral500, ";margin:0px 4px;");
export var largeDot = /*#__PURE__*/css("width:12px;height:12px;background:", colour.neutral900, ";");